export var TypeActionProductionInfo;
(function (TypeActionProductionInfo) {
    TypeActionProductionInfo["Received"] = "ProductionInfo > Received";
    TypeActionProductionInfo["Start"] = "ProductionInfo > Start";
    TypeActionProductionInfo["Skip"] = "ProductionInfo > Skip";
    TypeActionProductionInfo["Boost"] = "ProductionInfo > Boost";
    TypeActionProductionInfo["BoostNotEnoughRecipeCost"] = "ProductionInfo > BoostNotEnoughRecipeCost";
    TypeActionProductionInfo["Add"] = "ProductionInfo > Add";
    TypeActionProductionInfo["ReAdd"] = "ProductionInfo > ReAdd";
    TypeActionProductionInfo["Update"] = "ProductionInfo > Update";
    TypeActionProductionInfo["Remove"] = "ProductionInfo > Remove";
    TypeActionProductionInfo["ConfirmRemove"] = "ProductionInfo > ConfirmRemove";
    TypeActionProductionInfo["Finish"] = "ProductionInfo > Finish";
    TypeActionProductionInfo["RecipeSelect"] = "ProductionInfo > RecipeSelect";
    TypeActionProductionInfo["Collect"] = "ProductionInfo > Collect";
    TypeActionProductionInfo["PreCollect"] = "ProductionInfo > PreCollect";
    TypeActionProductionInfo["PostCollect"] = "ProductionInfo > PostCollect";
    TypeActionProductionInfo["ProductionNotEnoughResources"] = "ProductionInfo > ProductionNotEnoughResources";
    TypeActionProductionInfo["SkipNotEnoughResources"] = "ProductionInfo > SkipNotEnoughResources";
    TypeActionProductionInfo["ProductionSkipConfirmed"] = "ProductionInfo > ProductionSkipConfirmed";
})(TypeActionProductionInfo || (TypeActionProductionInfo = {}));
export var actionProductionInfo = function (props) { return ({
    productionInfo: props,
    type: TypeActionProductionInfo.Received,
}); };
export var actionProductionInfoRemoveProduction = function (buildingId) { return ({
    buildingId: buildingId,
    type: TypeActionProductionInfo.Remove,
}); };
export var actionProductionInfoConfirmRemoveProduction = function (buildingId) { return ({
    buildingId: buildingId,
    type: TypeActionProductionInfo.ConfirmRemove,
}); };
export var actionProductionInfoFinishProduction = function (buildingId) { return ({
    buildingId: buildingId,
    type: TypeActionProductionInfo.Finish,
}); };
export var actionProductionStart = function (amount, buildingId, recipeId, resourceIds) { return ({
    amount: amount,
    buildingId: buildingId,
    recipeId: recipeId,
    resourceIds: resourceIds,
    type: TypeActionProductionInfo.Start,
}); };
export var actionProductionNotEnoughResources = function (amount, buildingId, recipeId, resourceIds) { return ({
    amount: amount,
    buildingId: buildingId,
    recipeId: recipeId,
    resourceIds: resourceIds,
    type: TypeActionProductionInfo.ProductionNotEnoughResources,
}); };
export var actionProductionAdd = function (buildingId, production) { return ({
    buildingId: buildingId,
    production: production,
    type: TypeActionProductionInfo.Add,
}); };
export var actionProductionReAdd = function (buildingId) { return ({
    buildingId: buildingId,
    type: TypeActionProductionInfo.ReAdd,
}); };
export var actionProductionSkip = function (building) { return ({
    building: building,
    type: TypeActionProductionInfo.Skip,
}); };
export var actionProductionSkipConfirmed = function (building) { return ({
    building: building,
    type: TypeActionProductionInfo.ProductionSkipConfirmed,
}); };
export var actionProductionBoost = function (building, recipe) { return ({
    building: building,
    recipe: recipe,
    type: TypeActionProductionInfo.Boost,
}); };
export var actionProductionBoostMissingRecipeCost = function (building, recipe, missingRecipeCost) { return ({
    building: building,
    missingRecipeCost: missingRecipeCost,
    recipe: recipe,
    type: TypeActionProductionInfo.BoostNotEnoughRecipeCost,
}); };
export var actionProductionUpdate = function (buildingId, production) { return ({
    buildingId: buildingId,
    production: production,
    type: TypeActionProductionInfo.Update,
}); };
export var actionProductionCollect = function (building, products) { return ({
    building: building,
    products: products,
    type: TypeActionProductionInfo.Collect,
}); };
export var actionProductionPreCollect = function (building, products) { return ({
    building: building,
    products: products,
    type: TypeActionProductionInfo.PreCollect,
}); };
export var actionProductionPostCollect = function (building, products) { return ({
    building: building,
    products: products,
    type: TypeActionProductionInfo.PostCollect,
}); };
export var actionProductionRecipeSelect = function (recipeId) { return ({
    recipeId: recipeId,
    type: TypeActionProductionInfo.RecipeSelect,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/actionProductionInfo.ts
// module id = 61
// module chunks = 3